import { render, staticRenderFns } from "./Grade.vue?vue&type=template&id=13ce597e&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"
import style0 from "./Grade.vue?vue&type=style&index=0&id=13ce597e&prod&lang=css"
import style1 from "./Grade.vue?vue&type=style&index=1&id=13ce597e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce597e",
  null
  
)

export default component.exports